const baseURL = 'https://portfolioapiamine-bca54136d27b.herokuapp.com'

export default baseURL;